import { c as t } from "../../../../index.esm-BeDSGXP5.js";
import { css as e } from "styled-components";
const r = (o) => o.componentColors.radioGroup, n = (o) => o.components.radioGroup.constants, a = ({ theme: o, RadioButton: i }) => /* @__PURE__ */ e([
  "position:absolute;opacity:0;cursor:pointer;height:1px;width:1px;&:focus{& ~ ",
  "{box-shadow:0 0 0 0.3rem ",
  ",0 0 0 0.5rem ",
  ";}}&:checked{& ~ ",
  "{background-color:",
  ";border-color:",
  ";&:after{display:block;}}}"
], i, r(o).radioButtonBackground, r(o).checked, i, r(o).checked, r(o).checked), s = ({ theme: o, error: i, bordered: l }) => /* @__PURE__ */ e([
  "position:absolute;height:2rem;width:2rem;border:0.2rem solid ",
  ";background-color:",
  ";border-radius:50%;",
  " ",
  " &:after{content:'';position:absolute;display:none;top:20%;left:20%;width:1.2rem;height:1.2rem;border-radius:50%;background:",
  ";}"
], i ? r(o).radioError : r(o).radioButtonBorder, r(o).radioButtonBackground, t({
  bottom: [
    o.space.sm,
    null,
    o.space.md
  ],
  left: [
    "1.1rem",
    null,
    "1.9rem"
  ]
}), l && t({
  top: [
    "1.9rem",
    null,
    "2.7rem"
  ],
  left: [
    "1.9rem",
    null,
    "2.7rem"
  ]
}), r(o).radioButtonBackground), d = ({ theme: o, bordered: i }) => /* @__PURE__ */ e([
  "display:block;position:relative;min-height:",
  ";user-select:none;cursor:pointer;",
  " ",
  ""
], o.space.md, t({
  paddingBottom: [
    o.space.sm,
    null,
    o.space.md
  ],
  paddingRight: [
    o.space.xs,
    null,
    o.space.sm
  ],
  paddingLeft: [
    "5rem",
    null,
    "5.8rem"
  ]
}), i && t({
  paddingY: [
    "1.9rem",
    null,
    "2.7rem"
  ],
  paddingRight: [
    o.space.sm,
    null,
    o.space.md
  ],
  paddingLeft: [
    "5.8rem",
    null,
    "6.6rem"
  ]
})), p = {
  constants: {
    defaultSquareSize: "4.8rem"
  },
  radioError: ({ theme: o }) => /* @__PURE__ */ e([
    "color:",
    ";width:100%;"
  ], r(o).radioError),
  fieldset: ({ theme: o }) => /* @__PURE__ */ e([
    "",
    " border:0;display:flex;flex-wrap:wrap;"
  ], o.resets.space),
  defaultContainer: {
    default: ({ theme: o }) => /* @__PURE__ */ e([
      "width:100%;box-sizing:border-box;&:first-child{",
      "}"
    ], t({
      marginTop: [
        o.space.sm,
        null,
        o.space.md
      ]
    })),
    horizontal: ({ theme: o }) => /* @__PURE__ */ e([
      "box-sizing:border-box;",
      ""
    ], t({
      marginTop: [
        o.space.sm,
        null,
        o.space.md
      ]
    })),
    square: ({ theme: o }) => /* @__PURE__ */ e([
      "display:inline-block;margin:0 ",
      " ",
      " 0;box-sizing:border-box;",
      ""
    ], o.space.xs, o.space.xs, t({
      width: n(o).defaultSquareSize
    }))
  },
  borderedContainer: ({ theme: o, checked: i }) => /* @__PURE__ */ e([
    "border-style:solid;border-color:",
    ";border-width:0.3rem;margin-bottom:",
    ";&:first-child{",
    "}"
  ], i ? r(o).checked : r(o).containerBorder, o.space.sm, t({
    marginTop: 0
  })),
  radioOption: {
    default: a,
    horizontal: a,
    square: ({ theme: o, RadioButton: i }) => /* @__PURE__ */ e([
      "position:absolute;opacity:0;cursor:pointer;height:1px;width:1px;& ~ *{",
      " z-index:1;}&:focus{& ~ ",
      "{",
      " @media (forced-colors:active){outline:2px solid Mark !important;outline-offset:2px;}}}&:checked,&:hover{& ~ ",
      "{background-color:",
      ";border-color:",
      ";color:",
      ";@media (forced-colors:active){outline:2px solid;outline-offset:2px;}}}"
    ], t({
      fontSize: [
        o.fontSizes.textMediumMobile,
        null,
        o.fontSizes.textSmallDesktop
      ],
      fontWeight: o.fontWeights.semiBold,
      color: r(o).squareUncheckedText
    }), i, o.components.forms.borderStyle, i, r(o).squareChecked, r(o).squareChecked, r(o).squareCheckedText)
  },
  radioButton: {
    default: s,
    horizontal: s,
    square: ({ theme: o }) => /* @__PURE__ */ e([
      "display:flex;align-items:center;justify-content:center;text-align:center;padding:",
      ";box-sizing:border-box;height:",
      ";z-index:1;width:100%;border-radius:0.4rem;border:0.2rem solid ",
      ";background:",
      ";& > span{color:inherit;font-weight:inherit;font-size:inherit;}"
    ], o.space.xs, n(o).defaultSquareSize, r(o).squareRadioButtonBorder, r(o).radioButtonBackground)
  },
  radioButtonLabel: {
    default: d,
    horizontal: d,
    square: () => /* @__PURE__ */ e([
      "position:relative;display:flex;user-select:none;align-items:center;justify-content:center;cursor:pointer;width:100%;padding:0;"
    ])
  }
};
export {
  p as default
};
